import { Spinner } from '@agro-club/agroclub-shared'
import { FC, useEffect } from 'react'
import { SampleRequestBlock } from './SampleRequestBlock'
import { SampleWithRequests } from '../../../pages/Samples/types'
import { Bid } from 'modules/domain/bid/types'

type Props = {
  bid: Bid
  setSummary: (number) => void
  samples: SampleWithRequests[]
  samplesRefetch: (silent?: boolean) => Promise<void>
}

export const BidSamples: FC<Props> = ({ bid, setSummary, samples, samplesRefetch }) => {
  useEffect(() => {
    if (!samples) return
    setSummary(samples.length)
  }, [samples, setSummary])

  if (!samples) {
    return <Spinner />
  }

  return (
    <SampleRequestBlock
      bidId={bid.id as any} // todo make it number
      bid={bid}
      data={samples}
      refetch={samplesRefetch}
    />
  )
}
